/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Personal_Training_TermsInputs */

const en_service_type_personal_training_terms = /** @type {(inputs: Service_Type_Personal_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`personal trainer, trainer, one to one training, partner training, duo training, weight loss, fat loss, muscle gain, gym coach, get fit`)
};

const pl_service_type_personal_training_terms = /** @type {(inputs: Service_Type_Personal_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trener personalny, trener, trening indywidualny, trening z trenerem, trening w parze, trening w duecie, redukcja, odchudzanie, budowa masy, siłownia z trenerem, forma`)
};

/**
* | output |
* | --- |
* | "personal trainer, trainer, one to one training, partner training, duo training, weight loss, fat loss, muscle gain, gym coach, get fit" |
*
* @param {Service_Type_Personal_Training_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_personal_training_terms = /** @type {((inputs?: Service_Type_Personal_Training_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Personal_Training_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_personal_training_terms(inputs)
	return en_service_type_personal_training_terms(inputs)
});